/**
 * Email Service for form submissions
 *
 * This uses the Web3Forms API (free, no backend required)
 * Sign up at: https://web3forms.com/
 *
 * To set up:
 * 1. Go to https://web3forms.com/
 * 2. Enter your email (info@nursetechmedical.com)
 * 3. Get your Access Key
 * 4. Add to .env file: REACT_APP_WEB3FORMS_KEY=your_key_here
 */

const WEB3FORMS_KEY = process.env.REACT_APP_WEB3FORMS_KEY || 'YOUR_ACCESS_KEY_HERE';

export const emailService = {
  /**
   * Send newsletter subscription
   */
  async subscribeNewsletter(email) {
    const formData = {
      access_key: WEB3FORMS_KEY,
      subject: 'New Newsletter Subscription',
      from_name: 'Cordflex™ Website',
      to_email: 'info@nursetechmedical.com',
      email: email,
      message: `New newsletter subscription from: ${email}`
    };

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (result.success) {
        return { success: true, message: 'Successfully subscribed to newsletter!' };
      } else {
        throw new Error(result.message || 'Subscription failed');
      }
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      throw new Error('Failed to subscribe. Please try again later.');
    }
  }
};

export default emailService;
